import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en.json';
import translationNL from './locales/nl.json';
import translationDE from './locales/de.json';
import translationFR from './locales/fr.json';
import translationFY from './locales/fy.json';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: (location.hostname === "localhost"),
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: translationEN
            },
            nl: {
                translation: translationNL
            },
            de: {
                translation: translationDE
            },
            fr: {
                translation: translationFR
            },
            fy: {
                translation: translationFY
            },
        }
    });

export default i18n;